import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useState } from 'react';

import Input from '~/components/common/input';

type CheckboxesProps = {
   name: string;
   label: React.ReactNode;
   id: string;
   // eslint-disable-next-line no-unused-vars
   onChange?: (name: string, checked: boolean) => void;
   isChild?: boolean;
   value?: boolean;
   count?: number;
};

const Checkboxes = ({ name, label, id, value, onChange, isChild }: CheckboxesProps) => {
   const [checked, setChecked] = useState(false);
   const router = useRouter();

   useEffect(() => {
      /**
       * Used in mobile only with reset button
       */
      setChecked(!!value);
   }, [value]);

   useEffect(() => {
      if (isChild) {
         const q = router.query['sub-category'] as string;
         const subs = [...(q?.split(',') || [])];
         subs.includes(name) && setChecked(true);
      } else if (['females', 'males'].includes(name)) {
         const q = router.query.gender as string;
         const genders = [...(q?.split(',') || [])];
         genders.includes(name) && setChecked(true);
      } else if (
         [
            'internal',
            'external',
            '24_hours_confirmation',
            'online_experience',
            'offline_experience',
         ].includes(name)
      ) {
         const q = router.query.venue_types as string;
         const venue_types = [...(q?.split(',') || [])];
         venue_types.includes(name) && setChecked(true);
      } else if (['families', 'kids', 'teens', 'adults'].includes(name)) {
         const q = router.query.suitable as string;
         const suitables = [...(q?.split(',') || [])];
         suitables.includes(name) && setChecked(true);
      } else if (router.query[name] || router.query.categories?.includes(name)) setChecked(true);
   }, [router, name, isChild]);

   return (
      <div className="flex">
         <Input
            type="checkbox"
            labelClassName={classNames('text-[15px] sm:text-[15px]')}
            className="items-center mb-4 focus:outline-none"
            name={name}
            label={
               <div>
                  {label}
                  {/* {count ? <span className="text-sm text-gray-500">({count})</span> : null} */}
               </div>
            }
            id={id}
            checked={checked}
            onChange={(e: React.FormEvent<HTMLInputElement>) => {
               setChecked(e.currentTarget.checked);
               onChange?.(name, e.currentTarget.checked);
            }}
         />
      </div>
   );
};
export default Checkboxes;
